import { useAtom } from '@reatom/npm-react'
import React from 'react'

import { USER_TRADING_ANALYTICS_PERIODS } from '@root/features/user/user-trading-analytics/models/user-trading-analytics-period'
import { USER_TRADING_ANALYTICS_PERIOD_LABEL_MAP } from '@root/features/user/user-trading-analytics/models/user-trading-analytics-period'
import { PeriodDropdown } from '@root/features/user/user-trading-analytics/ui/period-dropdown'
import { useBreakpoint } from '@root/shared'
import { useTranslation } from '@root/shared/localization'
import { SegmentControl } from '@root/shared/ui-kit'

import type { UserTradingAnalyticsModel } from '@root/features/user/user-trading-analytics/atoms'

type Props = {
  model: UserTradingAnalyticsModel
}

export const ProfileBoardStatisticsPeriod: React.FC<Props> = ({ model }) => {
  const { t } = useTranslation()
  const breakpoint = useBreakpoint()
  const isMobile = breakpoint === 'mobile'

  const [period, setPeriod] = useAtom(model.periodAtom)

  if (isMobile) {
    return <PeriodDropdown value={period} onChange={setPeriod} />
  }

  return (
    <SegmentControl value={period} onChange={setPeriod}>
      {USER_TRADING_ANALYTICS_PERIODS.map((period) => (
        <SegmentControl.Item key={period} value={period}>
          {t(USER_TRADING_ANALYTICS_PERIOD_LABEL_MAP[period]).toUpperCase()}
        </SegmentControl.Item>
      ))}
    </SegmentControl>
  )
}
